/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/* eslint-disable max-len */
import React from 'react'
import classNames from 'classnames'
import {
  getCurrencyByReq
} from 'AccountsUtils'

const TimeLinePrice = ({ price, nonAmend = false, currency, charge, index, item, handleDetailModalClick }) => {
  const borderClass = classNames('', {
    'timeLine-border__red': index === 1,
    'timeLine-border__yellow': index === 2,
    'timeLine-border__green': index === 3,
    'timeLine-border__grey': index > 3,
  })

  return (
    <div className="flex flex-between mb-005 mt-005 bg-semilight-gray">
      <div className={borderClass} />
      <div className={`flex flex-right  ${(charge !== 'dateChange') ? '' : 'flex-middle'} ${(charge !== 'dateChange') ? 'flex-column' : ''} pl-0015 pr-0015`}>
        {nonAmend ? (
          <div className={`c-black-80 fw-600 ${(charge !== 'dateChange') ? 'flex flex-right' : ''}`} style={{ fontSize: '13px', lineHeight: '20px' }}>
            {'Non changeable'}
          </div>
        ) : (
          <div className={`c-black-80 fw-600 ${(charge !== 'dateChange') ? 'flex flex-right' : ''}`} style={{ fontSize: '13px', lineHeight: '20px' }}>
            {getCurrencyByReq(price, currency)} {charge === 'dateChange' && '+ Fare Difference'}
          </div>
        )}
        {(charge !== 'dateChange') && <div className="fs-12 " style={{ color: '#3366cc', lineHeight: '16px', marginBottom: '12px' }} onClick={() => handleDetailModalClick(item)}> {'more info'}</div>}

      </div>
    </div>
  )
}

export default TimeLinePrice
